import { parseCookies } from '@cian/utils';
import { setCookie } from '@cian/utils/lib/browser/cookie';
import { MOTIVATION_COOKIE_EXPIRATION, MOTIVATION_COOKIE_NAME } from '../../../shared/constants/favorites';

export const getAuthMotivationCookie = (): string | undefined => {
  const cookies = parseCookies(document.cookie);

  return cookies[MOTIVATION_COOKIE_NAME];
};

export const setAuthMotivationCookie = (): void => {
  setCookie(MOTIVATION_COOKIE_NAME, '1', {
    domain: '.cian.ru',
    expires: MOTIVATION_COOKIE_EXPIRATION,
    secure: false,
  });
};
